var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled, { ThemeProvider, css } from 'styled-components';
import { TickIcon } from '../../shared/icons';
import { FlexBox, CenterBox } from '../../shared/Element';
import Label from '../../shared/InputLabel';
import WithDynamicTopMargin from '../../shared/WithDynamicTopMargin';
import { doconTheme } from "../../../theme/default";
import { Heading3 } from '../doconHeadings/doconHeadings';
var Title = styled(Heading3)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 12px;\n"], ["\n  margin-bottom: 12px;\n"])));
var CheckboxContainer = styled(FlexBox)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: flex-start;\n  cursor: pointer;\n\n  ", " {\n    flex: 1;\n    padding-left: 8px;\n    margin-bottom: 0;\n    cursor: pointer;\n  }\n\n  ", "\n"], ["\n  align-items: flex-start;\n  cursor: pointer;\n\n  ", " {\n    flex: 1;\n    padding-left: 8px;\n    margin-bottom: 0;\n    cursor: pointer;\n  }\n\n  ", "\n"
    // Hide checkbox visually but remain accessible to screen readers.
    // Source: https://polished.js.org/docs/#hidevisually
])), Label, function (props) { return props.isDisabled && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    /* pointer-events: none; */\n    cursor: not-allowed;\n\n    ", " {\n      pointer-events: none;\n      cursor: not-allowed;\n      border-color: rgba(225, 224, 230, 0.7);\n      background-color: rgba(225, 224, 230, 0.7);\n    }\n\n    ", " {\n      cursor: not-allowed;\n    }\n  "], ["\n    /* pointer-events: none; */\n    cursor: not-allowed;\n\n    ", " {\n      pointer-events: none;\n      cursor: not-allowed;\n      border-color: rgba(225, 224, 230, 0.7);\n      background-color: rgba(225, 224, 230, 0.7);\n    }\n\n    ", " {\n      cursor: not-allowed;\n    }\n  "])), StyledCheckbox, Label); });
// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
var HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n  outline: none;\n"], ["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n  outline: none;\n"])));
var handleColor = function (props) {
    var _a = props.theme.v2.colors, input = _a.input, primary = _a.primary;
    return "\n    --input-bg-color: " + (props.checked ? primary[0] : input.bgColor) + ";\n    --input-border-color: " + (props.checked ? input.bgColor : input.borderColor) + ";\n    :hover {\n      --input-bg-color: " + (props.checked ? primary[0] : 'rgba(0, 137, 255, 0.08)') + ";\n    }\n  ";
};
var StyledCheckbox = styled(CenterBox)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 20px;\n  height: 20px;\n  background: var(--input-bg-color);\n  border: 1px solid var(--input-border-color);\n  border-radius: 4px;\n  transition: all 150ms;\n  ", ";\n\n  ", " {\n    color: white;\n    width: 15px;\n    visibility: ", "\n  }\n"], ["\n  width: 20px;\n  height: 20px;\n  background: var(--input-bg-color);\n  border: 1px solid var(--input-border-color);\n  border-radius: 4px;\n  transition: all 150ms;\n  ", ";\n\n  ", " {\n    color: white;\n    width: 15px;\n    visibility: ", "\n  }\n"])), function (props) { return handleColor(props); }, TickIcon, function (_a) {
    var checked = _a.checked;
    return (checked ? 'visible' : 'hidden');
});
var HocBox = WithDynamicTopMargin(CheckboxContainer);
export var Checkbox = function (_a) {
    var className = _a.className, name = _a.name, option = _a.option, _b = _a.checked, checked = _b === void 0 ? false : _b, _c = _a.isDisabled, isDisabled = _c === void 0 ? false : _c, onClick = _a.onClick, props = __rest(_a, ["className", "name", "option", "checked", "isDisabled", "onClick"]);
    function handleClick() {
        if (isDisabled)
            return;
        onClick && onClick({ name: name, value: option.value, isSelected: checked });
    }
    function handleChange(data) {
        console.log('object :>> ', data);
    }
    return (React.createElement(ThemeProvider, { theme: doconTheme },
        React.createElement(HocBox, __assign({ className: className, checked: checked, isDisabled: isDisabled }, props),
            React.createElement(HiddenCheckbox, { checked: checked, onChange: handleChange }),
            React.createElement(StyledCheckbox, { checked: checked, isDisabled: isDisabled, onClick: handleClick },
                React.createElement(TickIcon, null)),
            React.createElement(Label, { label: option.label, onClick: handleClick }))));
};
var DoconCheckbox = function (_a) {
    var name = _a.name, title = _a.title, className = _a.className, vertical = _a.vertical, options = _a.options, marginBetweenTop = _a.marginBetweenTop, _b = _a.selected, selected = _b === void 0 ? [] : _b, _c = _a.disabled, disabled = _c === void 0 ? [] : _c, onChange = _a.onChange, props = __rest(_a, ["name", "title", "className", "vertical", "options", "marginBetweenTop", "selected", "disabled", "onChange"]);
    function handleClick(_a) {
        var name = _a.name, value = _a.value, isSelected = _a.isSelected;
        if (!onChange)
            return;
        if (isSelected) {
            onChange({ name: name, value: selected.filter(function (e) { return e !== value; }) });
        }
        else {
            onChange({ name: name, value: __spreadArray(__spreadArray([], __read(selected), false), [value], false) });
        }
    }
    return (React.createElement(ThemeProvider, { theme: doconTheme },
        React.createElement(Title, { fontWeight: 'bold', title: title }),
        React.createElement(FlexBox, { vertical: vertical, gutter: 24, verticalSpace: 0, position: 'relative' }, (options || []).map(function (option) { return (React.createElement(Checkbox, { key: "" + option.value, name: name, option: option, marginBetweenTop: marginBetweenTop, isDisabled: disabled.includes(option.value), checked: selected.includes(option.value), onClick: handleClick })); }))));
};
export default DoconCheckbox;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
